export const generate_trans_ref = () => {
  const array = new Uint32Array(1);
  window.crypto.getRandomValues(array);

  for (const num of array) {
    return num;
  }
};
